import React, { useState, useEffect, useRef } from 'react'
import { emitirRelatorio } from '../../../util/AcessoApi'
import { ConsultaRelatorio } from '../../../components/RelatorioPadrao'
import { InputTipoRelatorio, InputSimNao, InputTipoProduto, InputProduto, InputFornecedor } from '../../../components/InputsAutoComplete'
import { InputDatePicker } from '../../../components/Inputs'
import { BotaoPadrao } from '../../../components/Botoes'
import { Formik, Form } from 'formik'
import ContentLoader from 'react-content-loader'
import Yup, { validaData } from '../../../util/Validacoes'
import { Link } from 'react-router-dom'

export default props => {
    const [filtros, setFiltros] = useState([])
    const [showModalFiltros, setShowModalFiltros] = useState(true)
    const [titulo, setTitulo] = useState('Relatórios de Produtos')
    const [dados, setDados] = useState([])
    const [relatorioSelecionado, setRelatorioSelecionado] = useState(0)
    const [valuesFiltros, setValuesFiltros] = useState({ tipo_relatorio: '' })
    const [relatorioAtual, setRelatorioAtual] = useState({})
    const [carregando, setCarregando] = useState(false)
    const [carregandoFiltros, setCarregandoFiltros] = useState(false)

    const tipoRelatorio = [
        { label: 'Relatório Geral de Produto', value: 1 },
        { label: 'Relatório Geral de Produto Entrada - Fornecedor', value: 4 },
        { label: 'Relatório Geral de Produto Saída - Responsável', value: 5 },
        { label: 'Relatório Geral de Produto - Saída', value: 2 },
        { label: 'Relatório Geral de Produto - Entrada', value: 3 },
    ]

    const validacao = Yup.object({
        data_aniversario_inicial: Yup.string().nullable()
            .test('Data Inicial', 'Data inválida!', function (value) { return validaData(this.parent.data_inicial) }),
        data_aniversario_final: Yup.string().nullable()
            .test('Data Final', 'Data inválida!', function (value) { return validaData(this.parent.data_final) })
    })

    const relatoriosPorTipo = propsFormik => [
        {
            titulo: 'Relatório Geral Produto',
            tipo: 1,
            url: '/relatorio/relatoriolistagemproduto',
            campos: [
                <InputTipoProduto label="Tipo Produto" placeholder="Tipo Produto" name="tipo_produto" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo autoFocus />,
                <InputProduto label="Produto" placeholder="Produto" name="produto" propsFormik={propsFormik} lasseTooltip={'tooltip-input-modal'} multiplo />,
                <InputSimNao label="Bloqueado?" placeholder="Bloqueado?" name="bloqueado" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} />,
            ],
            classeTr: 'linha-bottom-relatorio',
            agrupamento: [],
            colunas: [
                { label: 'Código', name: 'codigo', visivel: true, ordenamento: { tipo: 'numero', ativo: true }, width: '5%' },
                { label: 'Código de Barras', name: 'codigo_barras', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, width: '10%' },
                { label: 'Produto', name: 'produto', visivel: true, ordenamento: { tipo: 'texto', ativo: false, }, width: '15%' },
                { label: 'Tipo Produto', name: 'produto_tipo', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, width: '10%' },
                { label: 'Estoque Max.', name: 'estoque_max', visivel: true, ordenamento: { tipo: 'numero', ativo: false }, alinhamento: 'text-right' },
                { label: 'Estoque Min.', name: 'estoque_min', visivel: true, ordenamento: { tipo: 'numero', ativo: false }, alinhamento: 'text-right' },
                { label: 'Saldo', name: 'quantidade', visivel: true, ordenamento: { tipo: 'numero', ativo: false }, alinhamento: 'text-right' },
                { label: 'Bloqueado?', name: 'bloqueado', visivel: false, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Unid. Medida', name: 'unidade_medida', visivel: false, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Peso', name: 'peso', visivel: false, ordenamento: { tipo: 'numero', ativo: false }, alinhamento: 'text-right' },
                { label: 'Tamanho', name: 'tamanho', visivel: false, ordenamento: { tipo: 'numero', ativo: false }, alinhamento: 'text-right' },
                { label: 'Cor', name: 'produto_cor', visivel: false, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Observação', name: 'observacao', visivel: false, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Data Registro', name: 'data_registro', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, alinhamento: 'text-center' },

            ],
            data: [],
            colunasFiltros: [
                { label: 'Tipo Produto', name: 'tipo_produto', name_coluna: 'tipo_produto' },
                { label: 'Produtos', name: 'produto', name_coluna: 'produto' },
                { label: 'Bloqueado? ', name: 'bloqueado', name_coluna: 'bloqueado' },
            ]
        }, {
            titulo: 'Relatório Geral Produto - Saída',
            tipo: 2,
            url: '/relatorio/relatoriolistagemsaidaproduto',
            campos: [
                <InputTipoProduto label="Tipo Produto" placeholder="Tipo Produto" name="tipo_produto" propsFormik={propsFormik}
                    classeTooltip={'tooltip-input-modal'} multiplo autoFocus />,
                <InputProduto label="Produto" placeholder="Produto" name="produto" propsFormik={propsFormik}
                    classeTooltip={'tooltip-input-modal'} multiplo autoFocus />,
                <InputFornecedor label="Responsável" placeholder="Responsável" name="fornecedor" propsFormik={propsFormik}
                    classeTooltip={'tooltip-input-modal'} multiplo autoFocus />,
                <InputDatePicker label="Data Saída Inicial" name="data_saida_inicial" type="text"
                    setarValor={value => { propsFormik.setFieldValue("data_saida_inicial", value) }} modal classeTooltip={'tooltip-input-modal'} />,
                <InputDatePicker label="Data Saída Final" name="data_saida_final" type="text"
                    setarValor={value => { propsFormik.setFieldValue("data_saida_final", value) }} modal classeTooltip={'tooltip-input-modal'} />
            ],
            classeTr: 'linha-bottom-relatorio',
            colunas: [
                { label: 'Código', name: 'codigo', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, width: '5%' },
                { label: 'Código de Barras', name: 'codigo_barras', visivel: true, ordenamento: { tipo: 'texto', ativo: false, }, width: '10%' },
                { label: 'Data Saída ', name: 'data_saida', visivel: true, ordenamento: { tipo: 'data', ativo: false }, width: '7%', alinhamento: 'text-center' },
                { label: 'Produto', name: 'produto', visivel: true, ordenamento: { tipo: 'texto', ativo: false, } },
                { label: 'Tipo Produto', name: 'tipo_produto', visivel: true, ordenamento: { tipo: 'texto', ativo: false, }, width: '10%' },
                { label: 'Quantidade', name: 'quantidade', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, alinhamento: 'text-right', totalizar: true },
                { label: 'Responsável', name: 'fornecedor', visivel: false, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Data Registro', name: 'data_registro_formatada', visivel: false, ordenamento: { tipo: 'data', ativo: false }, alinhamento: 'text-center' },

            ],
            data: [],
            colunasFiltros: [
                { label: 'Tipo Produto', name: 'tipo_produto', name_coluna: 'tipo_produto' },
                { label: 'Produtos', name: 'produto', name_coluna: 'produto' },
                { label: 'Responsável', name: 'fornecedor', name_coluna: 'fornecedor' },
                { label: 'Data Saída Inicial', name: 'data', name_coluna: 'data_saida_inicial' },
                { label: 'Data Saída Final', name: 'data', name_coluna: 'data_saida_final' },
            ]
        }, {
            titulo: 'Relatório Geral Produto - Entrada',
            tipo: 3,
            url: '/relatorio/relatoriolistagementradaproduto',
            campos: [
                <InputTipoProduto label="Tipo Produto" placeholder="Tipo Produto" name="tipo_produto" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo autoFocus />,
                <InputProduto label="Produto" placeholder="Produto" name="produto" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputFornecedor label="Fornecedor" placeholder="Fornecedor" name="fornecedor_responsavel" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputFornecedor label="Cliente" placeholder="Cliente" name="cliente" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputDatePicker label="Data Entrada Inicial" name="data_entrada_inicial" type="text" setarValor={value => { propsFormik.setFieldValue("data_entrada_inicial", value) }} modal classeTooltip={'tooltip-input-modal'} />,
                <InputDatePicker label="Data Entrada Final" name="data_entrada_final" type="text" setarValor={value => { propsFormik.setFieldValue("data_entrada_final", value) }} modal classeTooltip={'tooltip-input-modal'} />
            ],
            classeTr: 'linha-bottom-relatorio',
            colunas: [
                { label: 'Código', name: 'codigo', visivel: true, ordenamento: { tipo: 'texto', ativo: true }, width: '5%' },
                { label: 'Código de Barras', name: 'codigo_barras', visivel: true, ordenamento: { tipo: 'texto', ativo: false, }, width: '10%' },
                { label: 'Data Entrada ', name: 'data_entrada', visivel: true, ordenamento: { tipo: 'data', ativo: false }, width: '7%', alinhamento: 'text-center' },
                { label: 'Produto', name: 'produto', visivel: true, ordenamento: { tipo: 'texto', ativo: false, } },
                { label: 'Tipo Produto', name: 'tipo_produto', visivel: true, ordenamento: { tipo: 'texto', ativo: false, }, width: '10%' },
                { label: 'Quantidade', name: 'quantidade', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, alinhamento: 'text-right', totalizar: true },
                { label: 'Fornecedor', name: 'fornecedor_responsavel', visivel: false, ordenamento: { tipo: 'texto', ativo: false } },
                
                { label: 'TAG(Cliente)', name: 'cliente_tag', visivel: false, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Data Registro', name: 'data_registro_formatada', visivel: false, ordenamento: { tipo: 'data', ativo: false }, alinhamento: 'text-center' },
            ],
            data: [],
            colunasFiltros: [
                { label: 'Tipo Produto', name: 'tipo_produto', name_coluna: 'tipo_produto' },
                { label: 'Produtos', name: 'produto', name_coluna: 'produto' },
                { label: 'Fornecedor', name: 'fornecedor_responsavel', name_coluna: 'fornecedor_responsavel' },
                { label: 'Cliente', name: 'cliente', name_coluna: 'cliente' },
                { label: 'Data Entrada Inicial', name: 'data', name_coluna: 'data_entrada_inicial' },
                { label: 'Data Entrada Final', name: 'data', name_coluna: 'data_entrada_final' },
            ]
        }, {
            titulo: 'Relatório Geral de Produto Entrada - Fornecedor',
            tipo: 4,
            url: '/relatorio/relatorioprodutoporfornecedor',
            campos: [
                <InputTipoProduto label="Tipo Produto" placeholder="Tipo Produto" name="tipo_produto" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo autoFocus />,
                <InputProduto label="Produto" placeholder="Produto" name="produto" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputFornecedor label="Fornecedor" placeholder="Fornecedor" name="fornecedor" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputFornecedor label="Cliente" placeholder="Cliente" name="cliente" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputSimNao label="Bloqueado?" placeholder="Bloqueado?" name="bloqueado" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} />,
                <InputDatePicker label="Data Entrada Inicial" name="data_entrada_inicial" type="text" setarValor={value => { propsFormik.setFieldValue("data_entrada_inicial", value) }} modal classeTooltip={'tooltip-input-modal'} />,
                <InputDatePicker label="Data Entrada Final" name="data_entrada_final" type="text" setarValor={value => { propsFormik.setFieldValue("data_entrada_final", value) }} modal classeTooltip={'tooltip-input-modal'} />
            ],
            classeTr: 'linha-bottom-relatorio',
            colunas: [
                { label: 'Data', name: 'data_entrada', visivel: true, ordenamento: { tipo: 'data', ativo: true }, width: '10%' },
                { label: 'Fornecedor', name: 'fornecedor_nome', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, width: '30%' },
                { label: 'Cliente', name: 'cliente_nome', visivel: true, ordenamento: { tipo: 'texto', ativo: false, }, width: '30%' },
                { label: 'Nota Fiscal', name: 'nota_fiscal', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, width: '10%' },
                { label: 'Lote', name: 'lote', visivel: true, ordenamento: { tipo: 'texto', ativo: false } },
                { label: 'Validade', name: 'validade', visivel: true, ordenamento: { tipo: 'data', ativo: false }, alinhamento: 'text-center' },
                { label: 'Quantidade', name: 'quantidade', visivel: true, ordenamento: { tipo: 'numero', ativo: false }, alinhamento: 'text-right' },
            ],
            data: [],
            numerarLinha: false,
            colunasFiltros: [
                { label: 'Tipo Produto', name: 'tipo_produto', name_coluna: 'tipo_produto' },
                { label: 'Produto', name: 'produto', name_coluna: 'produto' },
                { label: 'Fornecedor', name: 'fornecedor', name_coluna: 'fornecedor' },
                { label: 'Cliente', name: 'cliente', name_coluna: 'cliente' },
                { label: 'Bloqueado? ', name: 'bloqueado', name_coluna: 'bloqueado' },
                { label: 'Data Entrada Inicial', name: 'data', name_coluna: 'data_entrada_inicial' },
                { label: 'Data Entrada Final', name: 'data', name_coluna: 'data_entrada_final' },
            ],
            relatorioEspecifico: (dados, arrayConfigCol, configOrdenamento) => relatorioProdutoPorFornecedor(dados, arrayConfigCol, configOrdenamento)
        }, {
            titulo: 'Relatório Geral de Produto Saída - Responsável',
            tipo: 5,
            url: '/relatorio/relatorioprodutoporresponsavel',
            campos: [
                <InputTipoProduto label="Tipo Produto" placeholder="Tipo Produto" name="tipo_produto" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo autoFocus />,
                <InputProduto label="Produto" placeholder="Produto" name="produto" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputFornecedor label="Responsável" placeholder="Responsável" name="fornecedor" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} multiplo />,
                <InputSimNao label="Bloqueado?" placeholder="Bloqueado?" name="bloqueado" propsFormik={propsFormik} classeTooltip={'tooltip-input-modal'} />,
                <InputDatePicker label="Data Saída Inicial" name="data_saida_inicial" type="text" setarValor={value => { propsFormik.setFieldValue("data_saida_inicial", value) }} modal classeTooltip={'tooltip-input-modal'} />,
                <InputDatePicker label="Data Saída Final" name="data_saida_final" type="text" setarValor={value => { propsFormik.setFieldValue("data_saida_final", value) }} modal classeTooltip={'tooltip-input-modal'} />
            
            ],
            classeTr: 'linha-bottom-relatorio',
            colunas: [
                { label: 'Data', name: 'data_entrada', visivel: true, ordenamento: { tipo: 'data', ativo: true }, width: '10%', alinhamento: 'text-center' },
                { label: 'Responsável', name: 'fornecedor_nome', visivel: true, ordenamento: { tipo: 'texto', ativo: false }, width: '50%' },
                { label: 'Quantidade', name: 'quantidade', visivel: true, ordenamento: { tipo: 'numero', ativo: false }, alinhamento: 'text-right' },
            ],
            data: [],
            numerarLinha: false,
            colunasFiltros: [
                { label: 'Tipo Produto', name: 'tipo_produto', name_coluna: 'tipo_produto' },
                { label: 'Produto', name: 'produto', name_coluna: 'produto' },
                { label: 'Responsavel', name: 'fornecedor', name_coluna: 'fornecedor' },
                { label: 'Bloqueado? ', name: 'bloqueado', name_coluna: 'bloqueado' },
                { label: 'Data Saída Inicial', name: 'data', name_coluna: 'data_saida_inicial' },
                { label: 'Data Saída Final', name: 'data', name_coluna: 'data_saida_final' },
            ],
            relatorioEspecifico: (dados, arrayConfigCol, configOrdenamento) => relatorioProdutoPorResponsavel(dados, arrayConfigCol, configOrdenamento)
        },
    ]


    const submit = (values, propsFormik) => {
        setCarregando(true)
        let novoRelatorio = relatoriosPorTipo(propsFormik).find(x => x.tipo === relatorioSelecionado)

        if (novoRelatorio.tipo === relatorioAtual.tipo)
            novoRelatorio.colunas = relatorioAtual.colunas

        setShowModalFiltros(false)

        for (let i = Object.keys(values).length; i > 0; i--)
            if (Array.isArray(values[Object.keys(values)[i]]) && values[Object.keys(values)[i]].length === 0 || !values[Object.keys(values)[i]])
                delete values[Object.keys(values)[i]]

        setValuesFiltros(values)
        setRelatorioAtual({ ...novoRelatorio })

        if (values.tipo_relatorio)
            setFiltros(Object.keys(values).map((x, idx, array) => {
                const valorAtual = values[x]

                return (x !== 'tipo_relatorio'
                    && (typeof valorAtual === 'string' ? valorAtual : (valorAtual && valorAtual.length ? valorAtual.map(y => y.value).length : (valorAtual && valorAtual.value ? valorAtual.value.length : valorAtual))) &&
                {
                    coluna: novoRelatorio.colunasFiltros.find(y => y.name_coluna === x) !== undefined && novoRelatorio.colunasFiltros.find(y => y.name_coluna === x).name_coluna,
                    filtro: novoRelatorio.colunasFiltros.find(y => y.name_coluna === x) !== undefined && novoRelatorio.colunasFiltros.find(y => y.name_coluna === x).label,
                    name: novoRelatorio.colunasFiltros.find(y => y.name_coluna === x) !== undefined && novoRelatorio.colunasFiltros.find(y => y.name_coluna === x).name,
                    value: typeof valorAtual === 'string' ? valorAtual : valorAtual.length ? valorAtual.map(y => y.value) : valorAtual.value,
                    dado: typeof valorAtual === 'string' ? valorAtual : valorAtual.length ? valorAtual.map(y => y.label).toString().split(',').join(', ') : valorAtual.label
                })
            }
            ).filter(x => x))
        else {
            setRelatorioAtual({})
            setCarregando(false)
            setDados([])
            setFiltros([])
        }
    }

    useEffect(() => {
        let cloneRelatorioAtual = { ...relatorioAtual }

        cloneRelatorioAtual.url &&
            emitirRelatorio(cloneRelatorioAtual.url, cloneRelatorioAtual.titulo, { value: filtros },
                array => {
                    cloneRelatorioAtual.data = array
                    setTitulo(cloneRelatorioAtual.titulo)
                    setDados([{ numerarLinha: cloneRelatorioAtual.numerarLinha !== undefined ? cloneRelatorioAtual.numerarLinha : true, colunas: cloneRelatorioAtual.colunas, data: cloneRelatorioAtual.data, relatorioEspecifico: !!cloneRelatorioAtual.relatorioEspecifico ? (dados, arrayConfigCol, configOrdenamento) => cloneRelatorioAtual.relatorioEspecifico(dados, arrayConfigCol, configOrdenamento) : null }])
                    setRelatorioAtual(cloneRelatorioAtual)
                    setCarregando(false)
                })
    }, [filtros])

    const changeTipo = value => {
        setCarregandoFiltros(true)
        setFiltros([])
        setValuesFiltros({ tipo_relatorio: tipoRelatorio.find(x => x.value === value) })
        setRelatorioSelecionado(value)
        setDados([])
        setRelatorioAtual({})
        setTitulo('Relatórios de Produtos')
    }

    return (
        <ConsultaRelatorio showModalFiltros={showModalFiltros} setShowModalFiltros={setShowModalFiltros} dados={dados} titulo={titulo} filtros={filtros} setFiltros={setFiltros}
            loading={carregando} limparFiltrosFormik={() => setValuesFiltros({ tipo_relatorio: valuesFiltros.tipo_relatorio })} setRelatorioAtual={setRelatorioAtual} relatorioAtual={relatorioAtual}>
            <Formik
                initialValues={valuesFiltros}
                enableReinitialize={true}
                validationSchema={validacao}
                onSubmit={(values, propsFormik) => submit(values, propsFormik)}>
                {propsFormik => (<Form>
                    <div className='row'>
                        <InputTipoRelatorio label="Tipo Relatório" name="tipo_relatorio" placeholder="Tipo Relatório" classeTooltip={'tooltip-input-modal'}
                            propsFormik={propsFormik} autoFocus tipoRelatorio={tipoRelatorio} setRelatorioSelecionado={changeTipo} obrigatorio={true} />
                        {relatoriosPorTipo(propsFormik).find(x => x.tipo === relatorioSelecionado) && <div className={carregandoFiltros ? 'd-none' : ''} style={{ width: '100%' }}>
                            {relatoriosPorTipo(propsFormik).find(x => x.tipo === relatorioSelecionado).campos.map(
                                (item, idx, array) => {
                                    if (idx === (array.length - 1)) {
                                        setTimeout(() => {
                                            setCarregandoFiltros(false)
                                        }, 1000)
                                    }
                                    return item
                                }
                            )}
                        </div>}
                        {carregandoFiltros === true ?
                            <ContentLoader speed={2} width='100%' height='400' backgroundColor="#f3f3f3" foregroundColor="#e4e4e4" {...props} >
                                <rect x="12" y="10" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="30" rx="3" ry="3" width="355" height="50" />
                                <rect x="12" y="100" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="120" rx="3" ry="3" width="355" height="50" />
                                <rect x="12" y="190" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="210" rx="3" ry="3" width="355" height="50" />
                                <rect x="12" y="280" rx="3" ry="3" width="170" height="10" />
                                <rect x="12" y="300" rx="3" ry="3" width="355" height="50" />
                            </ContentLoader>
                            : <></>}
                    </div>
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Filtrar' disabled={false} />
                    </div>
                </Form>)}
            </Formik>
        </ConsultaRelatorio>
    )
}

const relatorioProdutoPorFornecedor = (array, arrayConfigCol, configOrdenamento) => {
    return (
        array && array.map((x, idx) =>
            <table className='table-agrupamento'>
                {(configOrdenamento.arrayOrdenamento[idx] && configOrdenamento.arrayOrdenamento[idx].filter(item => item === true).length > 0) && <tr><td colspan={`${x.colunas ? x.colunas.filter(y => y.visivel).length : 0}`}
                    className={'bold'}><Link to='#' className='d-none-print' onClick={() => configOrdenamento.limparOrdenamentos(idx)}>Remover ordenamentos</Link></td></tr>}
                {
                    x.data && x.data.map(produto => {
                        return (<>
                            <tr className="group-title">
                                {x.colunas && x.colunas.map((y, idy) => {
                                    let classes = (y.ordenamento ? 'ordenavel ' : '') + (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].ordenamento.ativo && arrayConfigCol[idx][idy].coluna === y.name ? 'ordenamento_' + arrayConfigCol[idx][idy].ordenamento.modo : '');
                                    return (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].visivel) && <td onClick={(event) => {
                                        if (y.ordenamento)
                                            configOrdenamento.setOrdenamento(idy, x.data, idx)
                                    }} style={{ width: y.width || 'auto' }} className={`bold coluna ${y.alinhamento && y.alinhamento || ''} ${classes}`}>{y.label}</td>
                                })}
                            </tr>
                            <tr className={'titulo-1'}>
                                <td colspan={x.colunas.length}>
                                    <div style={{ display: 'flex' }}>
                                        <span style={{ flex: 10 }}>{produto.codigo + ' - ' + produto.produto}</span>
                                        <span style={{ flex: 4 }}>{'Cod. Barras: ' + (produto.codigo_barras || '')}</span>
                                        <span style={{ flex: 4 }}>{'Tipo: ' + produto.produto_tipo_id + ' - ' + produto.produto_tipo_descricao}</span>
                                        <span style={{ flex: 2 }}>{'Bloq.: ' + produto.bloqueado}</span>
                                        <span style={{ flex: 2, textAlign: 'right' }}>{'Saldo: ' + produto.quantidade}</span>
                                    </div>
                                </td>
                            </tr>
                            <tr><td colspan={x.colunas.length}><span></span></td> </tr>
                            {
                                produto.entrada.length ?
                                    <>
                                        {
                                            configOrdenamento.arrayOrdenamento ? configOrdenamento.obterDataOrdenado(idx, produto.entrada).map(entrada => {
                                                return (
                                                    <tr className={`td-data`}>
                                                        {arrayConfigCol[idx].findIndex(name => name.coluna === 'data_entrada' && name.visivel) > -1 && <td>{entrada.data_entrada}</td>}
                                                        {arrayConfigCol[idx].findIndex(name => name.coluna === 'fornecedor_nome' && name.visivel) > -1 && <td>{entrada.fornecedor.codigo && entrada.fornecedor.nome ? (entrada.fornecedor.codigo + ' - ' + entrada.fornecedor.nome) : ''}</td>}
                                                        {arrayConfigCol[idx].findIndex(name => name.coluna === 'cliente_nome' && name.visivel) > -1 && <td>{entrada.cliente.codigo && entrada.cliente.nome ? (entrada.cliente.codigo + ' - ' + entrada.cliente.nome) : ''}</td>}
                                                        {arrayConfigCol[idx].findIndex(name => name.coluna === 'nota_fiscal' && name.visivel) > -1 && <td>{entrada.nota_fiscal || ''}</td>}
                                                        {arrayConfigCol[idx].findIndex(name => name.coluna === 'lote' && name.visivel) > -1 && <td>{entrada.lote || ''}</td>}
                                                        {arrayConfigCol[idx].findIndex(name => name.coluna === 'validade' && name.visivel) > -1 && <td className={'text-center'}>{entrada.validade}</td>}
                                                        {arrayConfigCol[idx].findIndex(name => name.coluna === 'quantidade' && name.visivel) > -1 && <td className={'text-right'}>{entrada.quantidade}</td>}
                                                    </tr>)
                                            }) : <></>
                                        }
                                        <tr className={`td-data`}>
                                            <td colspan={arrayConfigCol[idx].filter(x => x.visivel).length - 1}></td>
                                            <td className={'text-right bold'} >Total: {produto.entrada.reduce((acumulado, a) => acumulado + a.quantidade, 0)}</td>
                                        </tr>
                                    </>
                                    : <></>
                            }
                        </>
                        )
                    })
                }
            </table>
        )
    )
}

const relatorioProdutoPorResponsavel = (array, arrayConfigCol, configOrdenamento) => {
    return (
        array && array.map((x, idx) =>
            <table className='table-agrupamento'>
                {(configOrdenamento.arrayOrdenamento[idx] && configOrdenamento.arrayOrdenamento[idx].filter(item => item === true).length > 0) && <tr><td colspan={`${x.colunas ? x.colunas.filter(y => y.visivel).length : 0}`}
                    className={'bold'}><Link to='#' className='d-none-print' onClick={() => configOrdenamento.limparOrdenamentos(idx)}>Remover ordenamentos</Link></td></tr>}
                {
                    x.data && x.data.map(produto => {
                        return (<>
                            <tr className="group-title">
                                {x.colunas && x.colunas.map((y, idy) => {
                                    let classes = (y.ordenamento ? 'ordenavel ' : '') + (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].ordenamento.ativo && arrayConfigCol[idx][idy].coluna === y.name ? 'ordenamento_' + arrayConfigCol[idx][idy].ordenamento.modo : '');
                                    return (arrayConfigCol[idx][idy] && arrayConfigCol[idx][idy].visivel) && <td onClick={(event) => {
                                        if (y.ordenamento)
                                            configOrdenamento.setOrdenamento(idy, x.data, idx)
                                    }} style={{ width: y.width || 'auto' }} className={`bold coluna ${y.alinhamento && y.alinhamento || ''} ${classes}`}>{y.label}</td>
                                })}
                            </tr>
                            <tr className={'titulo-1'}>
                                <td colspan={x.colunas.length}>
                                    <div style={{ display: 'flex' }}>
                                        <span style={{ flex: 10 }}>{produto.codigo + ' - ' + produto.produto}</span>
                                        <span style={{ flex: 4 }}>{'Cod. Barras: ' + (produto.codigo_barras || '')}</span>
                                        <span style={{ flex: 4 }}>{'Tipo: ' + produto.produto_tipo_id + ' - ' + produto.produto_tipo_descricao}</span>
                                        <span style={{ flex: 2 }}>{'Bloq.: ' + produto.bloqueado}</span>
                                        <span style={{ flex: 2, textAlign: 'right' }}>{'Saldo: ' + produto.quantidade}</span>
                                    </div>
                                </td>
                            </tr>
                            <tr><td colspan={x.colunas.length}><span></span></td> </tr>
                            {
                                produto.entrada.length ?
                                    <>
                                        {
                                            configOrdenamento.arrayOrdenamento ? configOrdenamento.obterDataOrdenado(idx, produto.entrada).map(entrada => {
                                                return (
                                                    <tr className={`td-data`}>
                                                        {arrayConfigCol[idx].findIndex(name => name.coluna === 'data_entrada' && name.visivel) > -1 && <td className={'text-center'}>{entrada.data_entrada}</td>}
                                                        {arrayConfigCol[idx].findIndex(name => name.coluna === 'fornecedor_nome' && name.visivel) > -1 && <td>{entrada.fornecedor.codigo && entrada.fornecedor.nome ? (entrada.fornecedor.codigo + ' - ' + entrada.fornecedor.nome) : ''}</td>}
                                                        {arrayConfigCol[idx].findIndex(name => name.coluna === 'quantidade' && name.visivel) > -1 && <td className={'text-right'}>{entrada.quantidade}</td>}
                                                    </tr>)
                                            }) : <></>
                                        }
                                        <tr className={`td-data`}>
                                            <td colspan={arrayConfigCol[idx].filter(x => x.visivel).length - 1}></td>
                                            <td className={'text-right bold'} >Total: {produto.entrada.reduce((acumulado, a) => acumulado + a.quantidade, 0)}</td>
                                        </tr>
                                    </>
                                    : <></>
                            }
                        </>
                        )
                    })
                }
            </table>
        )
    )
}